var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
export default function renderBudget(value, config) {
  let currentValue;
  try {
    currentValue = JSON.parse(value || "{}");
  } catch (e) {
    currentValue = {};
  }
  const lines = (currentValue.lines || []).filter(({ label = "" }) => !!label);
  const $container = $("<div />");
  $container.addClass("formBuilder__budgetField-rendered");
  const $dataContainer = $("<pre />");
  $dataContainer.addClass("hidden");
  $dataContainer.html(JSON.stringify(__spreadProps(__spreadValues({}, currentValue), { lines }), null, 2));
  $container.append($dataContainer);
  const $table = $("<table />");
  $table.data("json", value);
  $table.addClass("table stack formBuilder__budgetField-table");
  const $tbody = $("<tbody />");
  const $tfoot = $("<tfoot />");
  let total = 0;
  lines.forEach((line) => {
    const $line = $("<tr />");
    $line.addClass("formBuilder__budgetField-line");
    const $label = $("<td />").prop("id", line.id);
    $label.addClass(
      "formBuilder__budgetField-cell formBuilder__budgetField-cell--label"
    );
    $label.text(line.label);
    $line.append($label);
    const $price = $("<td />");
    $price.addClass(
      "formBuilder__budgetField-cell formBuilder__budgetField-cell--price"
    );
    $price.append($("<span />").text(line.price));
    $price.append($("<span />").text(` ${config.currency}`));
    $line.append($price);
    total += line.price;
    $tbody.append($line);
  });
  $tfoot.append(
    $("<tr/>").append(
      $("<td/>").prop("colspan", 2).addClass(
        "formBuilder__budgetField-cell formBuilder__budgetField-cell--total"
      ).append(
        $("<span />").text(config.totalLabel + ` ${total}`).prop("alt", "total")
      ).append($("<span />").text(` ${config.currency}`))
    )
  );
  $table.append($tbody);
  $table.append($tfoot);
  $container.append($table);
  return $container;
}
